import { render } from "./LSPeriods.vue?vue&type=template&id=d9aa3762"
import script from "./LSPeriods.vue?vue&type=script&lang=js"
export * from "./LSPeriods.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__